module.exports = require('./lib/SanityObservableMinimal')



//////////////////
// WEBPACK FOOTER
// ./~/@sanity/observable/minimal.js
// module id = 55
// module chunks = 0